import type { ProcessedSet } from "@workspace/types";
import { isProgramSet, parseGenres } from "@workspace/types";
import { useMemo } from "react";

export function useArtistGenreData(processedSets: ProcessedSet[]) {
	const allGenres = useMemo(() => {
		const genres = new Set<string>();
		for (const set of processedSets) {
			if (!isProgramSet(set)) {
				if (set.is_collaborative && set.set_artists) {
					for (const setArtist of set.set_artists) {
						const artistGenres = parseGenres(
							setArtist.artist.spotify_genres || [],
							setArtist.artist.manual_genres || [],
						);
						for (const genre of artistGenres) {
							// Normalize to lowercase to prevent duplicates
							genres.add(genre.toLowerCase());
						}
					}
				} else if (set.artist) {
					const artistGenres = parseGenres(
						set.artist.spotify_genres || [],
						set.artist.manual_genres || [],
					);
					for (const genre of artistGenres) {
						// Normalize to lowercase to prevent duplicates
						genres.add(genre.toLowerCase());
					}
				}
			}
		}
		return Array.from(genres).sort((a, b) =>
			a.toLowerCase().localeCompare(b.toLowerCase()),
		);
	}, [processedSets]);

	const hasNoGenreArtists = useMemo(
		() =>
			processedSets
				.filter((set) => !isProgramSet(set))
				.some((set) =>
					set.is_collaborative && set.set_artists
						? set.set_artists.some(
								(setArtist) =>
									!setArtist.artist.spotify_genres ||
									setArtist.artist.spotify_genres.length === 0,
							)
						: !set.artist?.spotify_genres ||
							set.artist.spotify_genres.length === 0,
				),
		[processedSets],
	);

	return { allGenres, hasNoGenreArtists };
}
